export default {
  name: "Nama",
  tel: "telefon",
  save: "simpan",
  confirm: "sahkan",
  cancel: "Batal",
  delete: "padam",
  complete: "Selesai",
  loading: "Memuatkan...",
  telEmpty: "Sila isi no. telefon",
  nameEmpty: "Sila isikan nama anda",
  nameInvalid: "Sila masukkan nama yang betul",
  confirmDelete: "Adakah anda pasti ingin memadam?",
  telInvalid: "Sila masukkan no. telefon yang betul",
  vanCalendar: {
    end: "Selesai",
    start: "Mulakan",
    title: "Pemilihan Tarikh",
    confirm: "Pasti",
    startEnd: "Mula/Tamat",
    weekdays: ["Ahad", "Isnin", "Selasa", "Rabu", "Khamis", "Jumaat", "Sabtu"],
    monthTitle: function monthTitle(year, month) {
      return year + "\u0E1B\u0E35" + month + "\u0E40\u0E14\u0E37\u0E2D\u0E19";
    },
    rangePrompt: function rangePrompt(maxRange) {
      return (
        "\u0E08\u0E33\u0E19\u0E27\u0E19\u0E27\u0E31\u0E19\u0E17\u0E35\u0E48\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E15\u0E49\u0E2D\u0E07\u0E44\u0E21\u0E48\u0E40\u0E01\u0E34\u0E19 " +
        maxRange +
        " \u0E27\u0E31\u0E19"
      );
    }
  },
  vanCascader: {
    select: "sila pilih"
  },
  vanContactCard: {
    addText: "Tambah Kenalan"
  },
  vanContactList: {
    addText: "Buat Kenalan Baru"
  },
  vanPagination: {
    prev: "halaman sebelumnya",
    next: "halaman seterusnya"
  },
  vanPullRefresh: {
    pulling: "Tarik ke bawah untuk menyegarkan...",
    loosing: "Lepaskan untuk menyegarkan..."
  },
  vanSubmitBar: {
    label: "Jumlah:"
  },
  vanCoupon: {
    unlimited: "Tanpa syarat penggunaan",
    discount: function discount(_discount) {
      return "\u0E25\u0E14" + _discount;
    },
    condition: function condition(_condition) {
      return (
        "\u0E21\u0E35\u0E08\u0E33\u0E2B\u0E19\u0E48\u0E32\u0E22\u0E43\u0E19\u0E23\u0E32\u0E04\u0E32 " +
        _condition +
        " \u0E01\u0E27\u0E48\u0E32\u0E2B\u0E22\u0E27\u0E19"
      );
    }
  },
  vanCouponCell: {
    title: "Kupon",
    tips: "Tiada yang tersedia",
    count: function count(_count) {
      return "\u0E21\u0E35\u0E23\u0E39\u0E1B\u0E20\u0E32\u0E1E " + _count + " \u0E23\u0E39\u0E1B";
    }
  },
  vanCouponList: {
    empty: "Tiada kupon",
    exchange: "Tukarkan",
    close: "Tidak gunakan kupon",
    enable: "Boleh digunakan",
    disabled: "Tidak boleh digunakan",
    placeholder: "Sila masukkan kod kupon"
  },
  vanAddressEdit: {
    area: "Kawasan",
    postal: "Poskod",
    areaEmpty: "Sila pilih kawasan",
    addressEmpty: "Sila isi alamat lengkap",
    postalEmpty: "Format poskod tidak betul",
    defaultAddress: "Tetapkan sebagai alamat penghantaran lalai",
    telPlaceholder: "No. telefon penerima",
    namePlaceholder: "Nama penerima",
    areaPlaceholder: "Pilih negeri / bandar / daerah"
  },
  vanAddressEditDetail: {
    label: "Alamat Terperinci",
    placeholder: "Alamat jalan, nombor kedai, tingkat, dan bilik"
  },
  vanAddressList: {
    add: "Tambah Alamat"
  }
};



// WEBPACK FOOTER //
// ./src/i18n/vant-locales/ms-MY.js